import React from "react";
import { Navigate } from "react-router-dom";
import { useIsAuthenticated, useKlskDhp } from "@hilma/auth-core";

import { PrivateRouteProps } from "../types";

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  component: Component,
  componentName,
  redirectComponent: Rc,
  redirectPath = "/",
}) => {
  const { klsk } = useKlskDhp();
  const isAuthenticated = useIsAuthenticated();
  if (typeof Rc === "function") Rc = <Rc />;
  return klsk.indexOf(componentName) == -1 || !isAuthenticated ? (
    Rc ?? <Navigate to={redirectPath} />
  ) : typeof Component === "function" ? (
    <Component />
  ) : (
    Component
  );
};

export default PrivateRoute;
